module.exports = __webpack_public_path__ + "static/media/open-chest.b2e14dd3.mp3";